import { isMatching, P } from "ts-pattern";

export function isQueryNotFoundError(error: unknown) {
  return isQueryError(error) && error.status == 404;
}

const isQueryError = isMatching({ status: P.number });
